import React from 'react'
import './Body.css'

function Body() {
  return (
    <div className="bdy"> 
      <h1> Make remote work</h1>

      <p>Get your team in sync, no matter your location. Streamline processess, create team rituals and watch productivity soar.</p>
    
      <button>Learn more</button>
      
    </div>
  )
}

export default Body